import { FieldErrors } from 'react-hook-form'

import {
  IAddonsTypeInForm,
  IEditMenuItemFormData,
  IPackTypeInForm
} from '@/components-latest/ui/MenuPage/EditMenuItemModal'
import { IMenuItem } from '@/ducks/menu/menu.types'

export const mapMenuItemToEditModal = (
  menuItem: IMenuItem
): IEditMenuItemFormData => {
  return {
    food_name: menuItem.name?.en,
    price: menuItem.price,
    food_id: menuItem._id,
    maxQuantity: menuItem.maxOrderQuantity,
    addons: menuItem.addons.reduce((acc, addon) => {
      if (!addon._id) return acc
      acc[addon._id] = {
        visibility: addon.visibility as 0 | 1,
        price: addon.price
      }
      return acc
    }, {} as IAddonsTypeInForm),
    base_pack: menuItem.base_pack.reduce((acc, pack) => {
      if (!pack._id || pack?.sub_pack?.length === 0) return acc

      pack.sub_pack.forEach(({ _id, visibility, price }) => {
        acc[_id] = {
          visibility: visibility as 0 | 1,
          price: price,
          categoryId: pack._id
        }
      })

      return acc
    }, {} as IPackTypeInForm),
    type_pack: menuItem.type_pack.reduce((acc, pack) => {
      if (!pack._id || pack?.t_sub_pack?.length === 0) return acc

      pack?.t_sub_pack?.forEach(({ _id, visibility, price }) => {
        acc[_id] = {
          visibility: visibility as 0 | 1,
          price: price,
          categoryId: pack._id
        }
      })

      return acc
    }, {} as IPackTypeInForm),
    _modalPrice: 0
  }
}

export const getAddonsOrPacksErrorBoolean = (
  errors: FieldErrors<IEditMenuItemFormData>
) => {
  return (
    Object.values(errors?.addons || {}).some(
      error => error?.visibility?.message || error?.price?.message
    ) ||
    Object.values(errors?.type_pack || {}).some(
      error => error?.visibility?.message || error?.price?.message
    ) ||
    Object.values(errors?.base_pack || {}).some(
      error => error?.visibility?.message || error?.price?.message
    )
  )
}
